import { render } from "./TripTypeField.vue?vue&type=template&id=2e588077&scoped=true&ts=true"
import script from "./TripTypeField.vue?vue&type=script&lang=ts"
export * from "./TripTypeField.vue?vue&type=script&lang=ts"

import "./TripTypeField.vue?vue&type=style&index=0&id=2e588077&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e588077"]])

export default __exports__